// Importar todas as imagens dos assets
import camara from "./camara.jpg";
import logo from "./logo.png";

// Mapeamento de nomes de imagens para os imports
export const IMAGES = {
  "camara.jpg": camara,
  "logo.png": logo,

};

// Função para obter imagem por nome
export const getImage = (imageName) => {
  // Se não especificar nome, retornar null
  if (!imageName) return null;
  
  // Remover caminhos se existirem (ex: "/assets/camara.jpg" -> "camara.jpg")
  const cleanImageName = imageName.includes('/') 
    ? imageName.split('/').pop() 
    : imageName;
  
  // Primeiro, procurar por nome exato em IMAGES (assets estáticos)
  if (IMAGES[cleanImageName]) {
    return IMAGES[cleanImageName];
  }
  
  // Procurar por nome sem extensão em IMAGES
  const nameWithoutExt = cleanImageName.split('.')[0];
  if (IMAGES[nameWithoutExt]) {
    return IMAGES[nameWithoutExt];
  }
  
  // Procurar por correspondências parciais (case insensitive) em IMAGES
  const lowerCleanName = cleanImageName.toLowerCase();
  const foundKey = Object.keys(IMAGES).find(key => 
    key.toLowerCase() === lowerCleanName || 
    key.toLowerCase().includes(lowerCleanName.split('.')[0])
  );
  
  if (foundKey && IMAGES[foundKey]) {
    return IMAGES[foundKey];
  }
  
  // Se não encontrou em assets, tentar buscar em uploads (URL direta)
  // Imagens em /public/uploads são acessíveis via /uploads/nome.jpg
  return `/uploads/${cleanImageName}`;
};

// Lista de nomes de imagens disponíveis (para uso em formulários)
export const AVAILABLE_IMAGES = Object.keys(IMAGES).filter(key => key.includes('.'));

export default IMAGES;
